// Global imports
import 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes/plugins/rias/ls.rias'
import 'lazysizes/plugins/bgset/ls.bgset.min'

import Utils from './Utils'
import Mmenu from 'mmenu-js'
import Product from './Products.js'

class Header {
    constructor (theme, elem) {
        this._theme = theme
        this._name = this.constructor.name
        this._elem = elem
        this._utils = new Utils()
        this._product = new Product()
    }

    onInit () {
        const _this = this
        const body = document.querySelector('body')

        if (!body.classList.contains('non-index')) {
            window.addEventListener('scroll', function (e) {
                _this.headerBackground(body)
            })
            _this.headerBackground(body)
        }

        document
            .querySelectorAll('.js-hover')
            .forEach(function (e) {
                let hoverTarget = e.getAttribute('data-hover-target')
                let hoverTargetEl = document.querySelector(hoverTarget)
                let hoverTargetParent = e.getAttribute('data-hover-parent')
                let hoverParentEl = document.querySelector(hoverTargetParent)
                if (hoverTargetEl) {
                    e.addEventListener('mouseover', e => { _this.hoverHeaderShow(hoverTargetEl, true, body) })
                    hoverParentEl.addEventListener('mouseleave', e => { _this.hoverHeaderShow(null, false, body) })
                }
            })

        this.mobileMenuInit()
        this.showSearchForm()

        // Sitewide JS
        this.initVideo()
        this.initReadMore()
        this.initFilter()
        this._utils.overlayToggle()
        this._utils.initOverlay()
        this._utils.initNumberInputs()
        this._utils.initAccordion()
        this._utils.anchorLink()
    }

    showSearchForm () {
        const formHeader = document.querySelector('.form-group-header')
        const showSwitch = document.querySelector('.site-header-form-show')

        window.addEventListener('click', function (e) {
            if (e.target === showSwitch || showSwitch.contains(e.target) || formHeader.contains(e.target)) {
                formHeader.classList.add('form-group-header--open')
            } else {
                formHeader.classList.remove('form-group-header--open')
            }
        })
    }

    hoverHeaderShow (hoverTargetEl, show, body) {
        const solidBackground = 'site-header--solid'

        if (show) {
            document.querySelectorAll('.js-hover-target').forEach(function (e) {
                if (e !== hoverTargetEl) {
                    e.classList.remove('js-hover-show')
                } else {
                    e.classList.add('js-hover-show')
                }
            })
            if (!body.classList.contains('non-index')) {
                body.classList.add(solidBackground)
            }
        } else {
            document.querySelectorAll('.js-hover-target').forEach(function (e) {
                e.classList.remove('js-hover-show')
            })
            if (!body.classList.contains('non-index')) {
                body.classList.remove(solidBackground)
                this.headerBackground(body)
            }
        }
    }

    headerBackground (body) {
        if (!body.classList.contains('non-index')) {
            const solidBackground = 'site-header--solid'

            if (window.pageYOffset > 0) {
                body.classList.add(solidBackground)
            } else {
                body.classList.remove(solidBackground)
            }
        }
    }

    mobileMenuInit () {
        let mobileMenuHeader = document.querySelector('#mobile-nav-header')
        let mobileMenuHeaderClone = mobileMenuHeader.cloneNode(true)
        mobileMenuHeaderClone.classList.remove('hide')
        let mobileMenuHeaderString = mobileMenuHeaderClone.outerHTML

        document.addEventListener(
            'DOMContentLoaded', () => {
                const menu = new Mmenu('#mobile-nav', {
                    'extensions': [
                        'fullscreen'
                    ],
                    'navbars': [
                        {
                            'position': 'top',
                            'content': [
                                mobileMenuHeaderString,
                                'prev',
                                'title'
                            ]
                        }
                    ]
                })
                const api = menu.API

                document.querySelector('#close-mobile-menu')
                    .addEventListener(
                        'click', (evnt) => {
                            evnt.preventDefault()
                            api.close()
                        }
                    )
                document.querySelector('#mobile-nav').classList.remove('hide')
            }
        )
    }

    initVideo () {
        var videoSwitch = document.querySelectorAll('.video-switch')

        videoSwitch.forEach(function (e) {
            var video = e.querySelector('video')
            var videPlayButton = e.querySelector('.video-switch-play')
            videPlayButton.addEventListener('click', function () {
                if (video.paused) {
                    video.play()
                    videPlayButton.classList.add('hide')
                    video.setAttribute('controls', '')
                }
            })
        })
    }

    initReadMore () {
        let readMoreButtons = document.querySelectorAll('.js-read-more')
        readMoreButtons.forEach(function (el) {
            el.addEventListener('click', function (e) {
                let container = e.target.getAttribute('data-read-more')
                let containerEl = document.getElementById(container)

                if (containerEl) {
                    if (containerEl.classList.contains('js-read-more-closed')) {
                        containerEl.style.maxHeight = `${containerEl.scrollHeight}px`
                        containerEl.classList.add('js-read-more-open')
                        containerEl.classList.remove('js-read-more-closed')
                        el.textContent = 'Read Less'
                    } else {
                        containerEl.style.maxHeight = '300px'
                        containerEl.classList.add('js-read-more-closed')
                        containerEl.classList.remove('js-read-more-open')
                        el.textContent = 'Read More'
                    }
                }
            })
        })
    }

    initFilter () {
        let visibleFilters = document.querySelectorAll('.show-filter')
        let _this = this

        visibleFilters.forEach(function (el) {
            let hiddenParent = _this._utils.getClosestParent(el, '.hide')
            if (hiddenParent) {
                hiddenParent.classList.remove('hide')
            }
        })
    }
}

export default Header



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Header.js